import { createElementBlock as o, openBlock as t, createElementVNode as e } from "vue";
import n from "./index289.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(i, l, a, f, p, d) {
  return t(), o("svg", c, l[0] || (l[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#E5EDD7",
        d: "M13 32.445h35c-.665-4.434-2.646-8.136-5.939-11.103-3.329-2.969-7.18-4.453-11.561-4.453s-8.233 1.484-11.561 4.453C15.647 24.31 13.665 28.011 13 32.445Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M30.5 11.75c.647 0 1.18.492 1.244 1.122l.006.128v2.678c4.179.26 7.906 1.844 11.148 4.736 3.51 3.161 5.63 7.126 6.338 11.845A1.25 1.25 0 0 1 48 33.695l-16.25-.001v10.418a2.637 2.637 0 0 0 2.638 2.638 2.638 2.638 0 0 0 2.635-2.471l.005-.167a1.25 1.25 0 0 1 2.5 0c0 2.839-2.3 5.138-5.14 5.138a5.137 5.137 0 0 1-5.133-4.92l-.005-.218V33.694H13a1.25 1.25 0 0 1-1.236-1.435c.707-4.718 2.829-8.683 6.343-11.85 3.237-2.887 6.964-4.47 11.143-4.731V13c0-.69.56-1.25 1.25-1.25Zm0 6.389c-4.072 0-7.629 1.37-10.725 4.132-2.637 2.377-4.366 5.243-5.198 8.625l-.069.298h31.983l-.068-.298c-.797-3.242-2.417-6.008-4.87-8.322l-.324-.299C38.127 19.51 34.572 18.14 30.5 18.14Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ n(r, [["render", s]]);
export {
  _ as default
};
